import React from "react";

import { useAppSelector } from "../../../store/hooks";
import { getIcon } from "../../../utils/themeConfig";

function ProductConfirmationModal({ isOpen, onClose, onConfirm, orderItem }) {
  const { isPartsURL, isAccessoriesURL } = useAppSelector(
    (state) => state.domain
  );

  if (!isOpen) return null;

  const handleCancel = () => {
    if (onConfirm && orderItem) {
      onConfirm(orderItem);
    }
    onClose();
  };

  return (
    <div
      className="orders-cancel-modal-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        className="orders-cancel-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="cancelOrderTitle"
      >
        <div className="orders-cancel-modal-icon">
          <img
            src={getIcon("productConfirmation", isPartsURL, isAccessoriesURL)}
            alt="Cancel"
          />
        </div>
        <h3 className="orders-cancel-modal-title" id="cancelOrderTitle">
          Product Confirmation
        </h3>
        <p className="orders-cancel-modal-message">
          Are you sure you want to confirm this products as an order?
        </p>
        <div className="orders-cancel-modal-actions">
          <button
            type="button"
            className="orders-cancel-modal-cancel-btn"
            onClick={onClose}
          >
            Cancel
          </button>
          <button
            type="button"
            className={
              isPartsURL
                ? "orders-product-confirmation-modal-delete-btn-parts"
                : isAccessoriesURL
                ? "orders-product-confirmation-modal-delete-btn-acc"
                : "orders-product-confirmation-modal-delete-btn"
            }
            onClick={handleCancel}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}

export default ProductConfirmationModal;
